import { Chip, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useIsTruncated } from "../hooks/useIsTruncated";

export default function LookupChip({
  label,
  hex,
  variant = "filled",
  onDelete,
  sx,
}) {
  const theme = useTheme();
  const color = hex || theme.palette.primary.main;
  const [chipRef, isTruncated] = useIsTruncated(label);

  const styles = {
    filled: {
      bgcolor: color,
      color: theme.palette.getContrastText(color),
      maxWidth: 180,
    },
    outlined: { color, borderColor: color, maxWidth: 180 },
    plain: { maxWidth: 180 },
  };

  const chip = (
    <Chip
      ref={chipRef}
      label={label}
      size="small"
      variant={variant === "plain" ? "filled" : variant}
      onDelete={onDelete}
      sx={[styles[variant], sx]}
    />
  );

  return isTruncated ? <Tooltip title={label}>{chip}</Tooltip> : chip;
}
